export default __webpack_public_path__ + "static/media/rainyWindow.fc766f54.mp4";